import { onboardingImageUrl as resolveOnboardingImageUrl } from '../../shared/placeholder-media.js';

/** Deterministic placeholder art for onboarding choice cards. */
export function onboardingImageUrl(seed: string, width = 720, height = 900): string {
  return resolveOnboardingImageUrl(seed, width, height);
}
